<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
<!--       style="position: relative;"-->
<!--       class="widget-wrapper padT0 padB0"-->
<!--  >-->
    <!-- 상단 옵션 -->
    <div ref="chartWrapperOpts"
         class="widget-contents-option"
    >
      <div style="flex-grow: 1"/>
      <q-select style="width: 80px;"
                class="bs bs-q-sm bs-q-select bs-q-select-default"
                :value="opts.unit"
                :options="showTypeOptions"
                :auth-force="true"
                @change="onChangeChartOptions"
      />
    </div>
    <!-- 컨텐츠 영역 -->
<!--    <div class="widget-contents" style="position: absolute; top: 15px;">-->
    <div class="widget-contents">
        <!-- 차트 영역 -->
        <non-trend-chart ref="chartInstance"
                         class="widget-contents-chart"
                         :type="opts.chartType"
                         :x-axis="xAxis"
                         :y-axis="yAxis"
                         :tooltip="toolTip"
                         :data="widgetData"
                         :series-options="seriesOptions"
                         @resizeWidget="onResizeContentsFromWidget"
        />
    </div>
  </div>
</template>
<script>
import {widgetMixin} from '~/mixins/widgetCommonMixin'

import {createNamespacedHelpers} from 'vuex'
const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

export default {
  name: 'widgetSecAptMalHashTopn',
  directives: {},
  mixins: [widgetMixin],
  data () {
    return {
      w: 1,
      self: this,
      opts: {
        unit: 'md5',
        chartType: 'bar'
      },
      title: 'widgetSecAptMalHashTopn',
      isLock: false,
      isMove: true,
      isResize: true,
      eventBus: true,
      deviceType: [21],
      restData: {
        result: [],
        unit_time: ''
      },
      seriesOptions: {
        barWidth: '40%'
      },
      widgetData: []
    }
  },
  computed: {
    xAxis () {
      const self = this.self
      const xAxisOptions = {}

      if (this.opts.chartType === 'bar') {
        xAxisOptions.axisLabel = {
          formatter: (value) => {
            if (self.opts.unit === 'byte') {
              return `${this.byteConverter(value)}`
            } else {
              return `${this.kmgtConverter(value)}`
            }
          }
        }
      }

      return xAxisOptions
    },
    // yAxis () {
    //   const self = this.self
    //   return {
    //     title: '',
    //     labels: {
    //       nStep: self.opts.chartType === 'bar' ? 2 : void 0,
    //       style: {
    //         textOverflow: 'ellipsis'
    //       },
    //       rotation: 0
    //       // formatter () {
    //       //   if (self.opts.unit === 'byte') {
    //       //     return self.byteConverter(this.value)
    //       //   } else {
    //       //     return self.kmgtConverter(this.value)
    //       //   }
    //       // }
    //     },
    //     softMin: 0,
    //     softMax: 1
    //   }
    // },
    yAxis () {
      const self = this.self
      const yAxisOptions = {}

      if (this.opts.chartType === 'column') {
        yAxisOptions.axisLabel = {
          formatter: (value) => {
            if (self.opts.unit === 'byte') {
              return `${this.byteConverter(value)}`
            } else {
              return `${this.kmgtConverter(value)}`
            }
          }
        }
      }

      return yAxisOptions
    },
    // toolTip () {
    //   const self = this.self
    //   return {
    //     formatter () {
    //       return `<span style="color: ${this.color}">\u25CF</span>${this.key} : <strong>${self.separateByComma(this.y ? this.y : this.point.value)}${self.restData.unit_time}</strong>`
    //     }
    //   }
    // },
    toolTip () {
      const self = this.self
      return {
        formatter: (params) => {
          const {name, value, marker} = _.isArray(params) ? params[0] : params
          if (self.opts.unit === 'byte') {
            return `${marker} ${name} : <b>${this.byteConverter(value)}${this.restData.unit_time}</b>`
          } else {
            return `${marker} ${name} : <b>${this.separateByComma(value)}${this.restData.unit_time}</b>`
          }
        }
      }
    },
    showTypeOptions () {
      return [
        {
          label: _.upperCase(this.$t('an.md5')),
          value: 'md5'
        },
        {
          label: _.upperCase(this.$t('an.sha256')),
          value: 'sha256'
        }
      ]
    },
    widgetChartMenu () {
      return [
        {
          icon: 'icon-chart-pie',
          label: 'Pie Chart',
          value: 'pie'
        },
        {
          icon: 'icon-chart-bar',
          label: 'Bar Chart',
          value: 'bar'
        },
        {
          icon: 'icon-chart-column',
          label: 'Column Chart',
          value: 'column'
        },
        {
          icon: 'icon-chart-tree-map',
          label: 'Tree Map',
          value: 'treemap'
        }
      ]
    }
  },
  beforeDestroy () {
    // 셀프 객체 초기화
    this.self = null
  },
  methods: {
    ...mapActions([
      'getWidgetData'
    ]),
    // 위젯 대상 장비 필터 설정.
    async onChangeWidgetMachId ({ machId }) {
      // 위젯 옵션 변경 - 저장에 필요한 값???
      this.opts.mach_id = machId
      this.getWidgetContentsData(true, machId)
    },
    async getWidgetContentsData (init = false, extraParams = null) {
      const contentsOptions = {}

      // Progress 출력 여부
      this.showProgress(true)

      // initFlag가 True면 기존 차트 데이터 초기
      if (init) {
        // 위젯 데이터 초기화
        this.widgetData = []

        // Series 초기화
        this.$refs.chartInstance.clear()
      }

      if (this.opts.haMember) {
        contentsOptions.dataType = this.opts.haMember
      }

      // 장비 filter 추가
      if (this.opts.mach_id) {
        contentsOptions.machId = this.opts.mach_id
      }

      // 엑스트라 파라미터가 있는 경우 (IP Type 또는 HA Mamber/Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
      if (extraParams) {
        if (extraParams.haMember) {
          contentsOptions.dataType = extraParams.haMember
        }

        if (extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }
      }

      // API 조회
      const md5Options = {
        widgetType: 'apt_mal_hash_md5_top',
        ...contentsOptions
      }
      const sha256Options = {
        widgetType: 'apt_mal_hash_sha256_top',
        ...contentsOptions
      }

      const {code, result} = await this.getWidgetData(this.opts.unit === 'md5' ? md5Options : sha256Options)

      if (code === 'ok') {
        this.restData = result

        const maliciousHash = []
        for (const hash of this.restData.result || []) {
          // TAMS
          let parseName = ''
          try {
            parseName = hash.name || ''
            const splitName = parseName.split('(')
            parseName = splitName[1].length === 1 ? splitName[0] : parseName // 사용자 정보 유무 확인
          } catch (e) {
            parseName = hash.name
          }

          maliciousHash.push({
            // y: hash.value,
            // port: hash.port,
            name: parseName,
            value: hash.value
          })
        }

        this.widgetData = maliciousHash
      }

      // Progress 출력 여부
      this.showProgress(false)
    },
    /*
      이름: onChangeChartOptions
      설명: 차트의 출력 타입을 변경한다.
    */
    onChangeChartOptions (value) {
      this.opts.unit = value
      this.getWidgetContentsData()
    },
    /**
     * 이름: onResizeContentsFromWidget
     * 설명: APT 악성 해쉬 위젯의 리사이즈를 진행한다.
     */
    onResizeContentsFromWidget () {
      // Chart 래퍼 컨테이너 객체
      const chartWrapper = this.$refs.chartWrapper

      // 래퍼 체크 (임시 코드)
      // Chart 인스턴스
      if (chartWrapper && this.$refs.chartInstance) {
        let wrapperWidget = chartWrapper.clientWidth
        let wrapperHeight = chartWrapper.clientHeight < 223 ? 223 : chartWrapper.clientHeight || 223

        const chartInstance = this.$refs.chartInstance

        // Tooltip DOM 가져오기
        if (chartInstance.tooltip) {
          const tooltipDom = chartInstance.tooltip.container

          // Tooltip DOM 위치 초기화
          if (tooltipDom) {
            tooltipDom.style.left = 0
          }
        }

        wrapperWidget -= 30
        wrapperHeight -= 4

        if (this.isMaximumWidget) {
          wrapperHeight = this.parent.$el.clientHeight - 60 - 97
        }

        chartInstance.setSize(wrapperWidget, wrapperHeight - 15, false)
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-option {
    /*z-index: 1;*/
    right: 0;
    display: flex;
    /*position: absolute;*/
    padding-top: 5px;
    padding-right: 5px;
    margin-bottom: 5px;
  }

  /*.widget-contents-option select {*/
  /*  width: 100px;*/
  /*  height: 25px;*/
  /*  font-size: 10pt;*/
  /*}*/

  .widget-contents {
    display: flex;
  }

  .widget-contents-chart {
    flex: 1 !important;
  }

  .widget-contents-option select {
    width: 100px;
    height: 25px;
    font-size: 10pt;
  }
  /*.widget-contents-wrapper {*/
  /*  flex: 1;*/
  /*  display: flex;*/
  /*  position: relative;*/
  /*}*/

  /* column chart 시 필요 */
  th {
    color: #2d5582;
    height: 30px;
    border: 1px solid #c4d8f1;
    background-color: #e2ecf9 !important;
  }

  tr, td {
    border: 1px solid #c4d8f1;
    font-size: 9pt;
  }
</style>
